import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService,} from '../../_services/index';

@Component({
    standalone: false,
    selector: 'list-message-component',
    templateUrl: 'listMessage.message.component.html'
})

export class ListMessageComponent {
items: string[];
title: string;
    constructor(
      public dialogRef: MatDialogRef<ListMessageComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public router: Router,
      public route: ActivatedRoute,
      public alertService: AlertService,
      public authenticationService: AuthenticationService) {
this.items = data.items;
this.title = data.title;

    }

    onLogOff(): void{
        this.dialogRef.close();
        this.authenticationService.logout();
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
